<template>
  <div class="hi-lo-game">
    <div style="display:flex;">
      <div style="width:70%;">
        <hi-lo-card
          :game="game"
          :game-data="gameData"
          :minutes-string="minutesString"
          :seconds-string="secondsString"
          :showDrawingAnimation="showDrawingAnimation"
          :draw-result="drawResult"
          :count-down="countDown"
          @on-animation-end="gameOnAnimationEnd"
        />
      </div>
      <div style="width:30%">
        <hi-lo-high-low
          :game="game"
          :game-data="gameData"
          :disallow-betting="disallowBetting"
          :minutes-string="minutesString"
          :seconds-string="secondsString"
          :win-cell-no="`o${this.drawResult.hl}`"
        />

        <hi-lo-group
          :game="game"
          :game-data="gameData"
          :disallow-betting="disallowBetting"
          :minutes-string="minutesString"
          :seconds-string="secondsString"
          :win-cells="this.drawResult"
        />
      </div>
    </div>

    <div class="hi-lo-main-bet">
      <hi-lo-red-black
        :game="game"
        :game-data="gameData"
        :disallow-betting="disallowBetting"
        :minutes-string="minutesString"
        :seconds-string="secondsString"
        :win-cells="this.drawResult"
        :win-cell-no="
          `o${
            this.drawResult.joker == '0'
              ? this.drawResult.rb
              : this.drawResult.joker
          }`
        "
      />
    </div>
    <div class="hi-lo-no-bet">
      <hi-lo-number
        :game="game"
        :game-data="gameData"
        :disallow-betting="disallowBetting"
        :minutes-string="minutesString"
        :seconds-string="secondsString"
        :win-cell-no="`o${this.drawResult.sn}`"
      />
    </div>

    <div
      ref="hi-lo-disallow-betting-section"
      class="hi-lo-disallow-betting-section"
      v-if="displayDisallowSection"
    >
      <Row class="hi-lo-disallow-betting" type="flex" justify="center" align="middle">
        <Col>
          <div>{{ $t("general.no_more_bet") }}</div>
        </Col>
      </Row>
    </div>
  </div>
</template>

<script>
import { snakeCase } from "change-case";
import { random } from "lodash";
import { TweenLite, TimelineLite } from "gsap";
import { Row, Button, Timeline } from "iview";

import HiLoHighLow from "./hi-lo-game/HiLoHighLow";
import HiLoGroup from "./hi-lo-game/HiLoGroup";
import HiLoRedBlack from "./hi-lo-game/HiLoRedBlack";
import HiLoNumber from "./hi-lo-game/HiLoNumber";
import HiLoCard from "./hi-lo-game/HiLoCard";
import EventBus from "../../configs/event-bus";

export default {
  props: [
    "game",
    "gameData",
    "countDown",
    "drawResult",
    "showDrawingAnimation",
    "disallowBetting",
    "displayDisallowSection",
    "minutesString",
    "secondsString",
    "game-on-animation-end"
  ],
  components: {
    HiLoHighLow,
    HiLoGroup,
    HiLoRedBlack,
    HiLoNumber,
    HiLoCard,
    Row,
    Button
  },
  computed: {
    snakeCaseTitle() {
      return snakeCase(this.game);
    }
  },
  data() {
    return {};
  },
  watch: {
    showDrawingAnimation() {
      // console.log("ClearUpDownStake");
      // clearStakeRecord(this.gameData.gID);
      // EventBus.$emit("update-session-storage");
    }
  },
  mounted() {
    EventBus.$emit("update-session-storage");
  }
};
</script>

<style lang="scss" scoped>
.hi-lo-game {
  position: relative;
  background: #212121 url("../../assets/images/hi-lo/hilo-bg.jpg");
  background-size: cover;
  background-position: top;
  height: 373px;
}

.hi-lo-main-bet {
  display: flex;
  cursor: pointer; //1017 ADDED
}

.hi-lo-animation-section {
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.hi-lo-animation-section.hide {
  display: none;
}

.hi-lo-disallow-betting-section {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  color: white;
  background: rgba(#000000, 0.9);
  font-size: 16px;
  z-index: 100;
}

.hi-lo-stop-animation-section {
  position: absolute;
  display: none;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  color: white;
  background: rgba(#000000, 0.9);
  font-size: 16px;
}

.hi-lo-stop-animation-section.show {
  display: block;
}

.hi-lo-disallow-betting,
.hi-lo-stop-animation {
  width: 100%;
  height: 100%;
}

.hi-lo-animation-container {
  height: 100%;
  width: 100%;
  background: rgba(#000000, 0.9);
}

.hi-lo-animation-result {
  display: none;
  width: 100%;
  height: 100%;
}

.hi-lo-animation-result .hi-lo-animation-result-plate {
  width: 100%;
  height: auto;
  z-index: 99;
}

.hi-lo-animation-result-container,
.hi-lo-animation-banner-container {
  position: relative;
}

.hi-lo-animation-result-container {
  z-index: 2;
}

.hi-lo-animation-banner-container {
  display: none;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  padding: 0 20px;
  z-index: 1;
}

.hi-lo-animation-result-dice {
  display: none;
  width: 15%;
  position: absolute;
  top: 0;
  z-index: 100;
  border-radius: 6px;
  box-shadow: 0 0 4px 2px #00000044;
}

.hi-lo-animation-result-banner-top,
.hi-lo-animation-result-banner-sum {
  width: 85%;
  position: absolute;
  top: 25%;
}

.hi-lo-animation-result-banner-sum {
  top: 27%;
}

.hi-lo-animation-result-banner-sum-total {
  font-size: 24px;
  color: $tai-xiu-theme-color-6;
  font-weight: bold;
  font-size: 36px;
  line-height: 1;
}

.hi-lo-animation-result-banner-sum-title {
  color: white;
  font-weight: bold;
}

.hi-lo-animation-result-banner-bottom,
.hi-lo-animation-result-banner-game {
  width: 85%;
  position: absolute;
  bottom: 25%;
}

.hi-lo-animation-result-banner-game {
  bottom: 30%;
}

.hi-lo-animation-result-banner-game-result {
  padding: 5px;
  background-color: white;
  color: $tai-xiu-theme-color-3;
  font-weight: bold;
  width: 60px;
  margin: 0 5px;
  border-radius: 8px;
  text-align: center;
}

.hi-lo-game-animation-next-draw {
  background-color: $tai-xiu-theme-color-13;
  color: $tai-xiu-theme-color-5;
  border-radius: 6px;
  font-size: 14px;
  margin-right: 5px;
  padding: 4px 20px;
  font-weight: bolder;
  z-index: 1;
}

.hi-lo-game-animation-next-draw-section {
  position: absolute;
  top: 20px;
  width: 100%;
}

.hi-lo-animation-inner {
  position: relative;
  width: 100%;
}

.hi-lo-animation-banner-inner {
  height: 100%;
}

@media only screen and (max-width: 360px) {
  .hi-lo-animation-result-banner-sum {
    top: 26%;
  }

  .hi-lo-animation-result-banner-game {
    bottom: 29%;
  }
}
</style>
